import PropTypes from 'prop-types'
import ErrorIcon from '@/assets/svgs/icon-error-message-exclamation.svg?react'

const FormError = ({ message }) => (
  <div className="login-box__form__col--error flex items-center mt-2">
    <ErrorIcon className="grow-0 shrink-0 basis-5" />
    <span className="t--required text-red-50 ml-2.5 text-xs font-extrabold leading-4">
      {message}
    </span>
  </div>
)

FormError.propTypes = {
  message: PropTypes.string.isRequired,
}

export default FormError
